import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class RedirectRouterService {
  constructor(
    private readonly router: Router,
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: any,
    private readonly translateService: TranslateService
  ) {}

  goToPage(path: string) {
    const customCreateUrl = `/${this.translateService.currentLang}${path}`;
    this.redireccionExitosa(customCreateUrl);
  }

  redireccionExitosa(currentPath: string) {
    let params: any;
    if (currentPath.split('?').length > 1) {
      params = JSON.parse(
        '{"' +
          decodeURI(currentPath.split('?')[1])
            .replace(/"/g, '\\"')
            .replace(/&/g, '","')
            .replace(/=/g, '":"') +
          '"}'
      );
    }
    this.router.navigate([currentPath.split('?')[0]], { queryParams: params });
  }

  goToOutPage(path: string) {
    if (isPlatformBrowser(this.platformId)) window.open(path, '_blank');
  }
}
